import * as _ from 'lodash';
import gql from 'graphql-tag';

import {useQuery} from './query';
import {useMemo} from 'react';
import * as Filter from '../../util/filters';

import * as Generated from '../../generated/graphql';
import * as Run from '../../util/runs';

export const FILTER_VALUE_SUGGESTIONS = gql`
  query RunValueSuggestions(
    $projectName: String!
    $entityName: String
    $keyPath: String
    $filters: JSONString
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      name
      valueCounts(keyPath: $keyPath, filters: $filters)
    }
  }
`;

export interface RunValueSuggestionsData {
  project: {
    id: string;
    name: string;
    valueCounts: string;
  };
}

interface InputProps {
  entityName: string;
  projectName: string;
  keyPath: string;
  filters: Filter.Filter;
}

export function useRunValueSuggestionsQuery(inputProps: InputProps) {
  const variables = {
    ...inputProps,
    filters: JSON.stringify(Filter.toMongo(inputProps.filters)),
  };
  const result = useQuery<
    RunValueSuggestionsData,
    Generated.RunValueSuggestionsQueryVariables
  >(Generated.RunValueSuggestionsDocument, {
    fetchPolicy: 'cache-and-network',
    skip: inputProps.keyPath === '',
    variables,
  });

  const valueCounts =
    result.loading === false ? result.project.valueCounts : null;

  const valueSuggestions = useMemo(() => {
    if (valueCounts == null) {
      return [];
    }
    const json = JSON.parse(valueCounts);
    const values = json.values as number[];
    return _.compact(
      values.map((valCount, i) => {
        if (
          !_.isArray(valCount) ||
          valCount.length !== 2 ||
          !_.isNumber(valCount[1])
        ) {
          console.warn('invalid valueCount', valCount);
          return null;
        }
        const value = valCount[0];
        const count: number = valCount[1];
        const displayVal = Run.displayValue(value, 'null');
        return {
          text: displayVal,
          key: Run.domValue(value),
          value,
          count,
        };
      })
    );
  }, [valueCounts]);

  if (result.loading) {
    return {loading: true as true};
  }
  return {loading: false as false, valueSuggestions};
}
